import {
  FeatureFlagEntry,
  FeatureFlagGroup
} from 'v5/services/front/FeatureManagementService/types';

export function matchesFeatureFlagSearch(
  entry: FeatureFlagEntry,
  query: string
): boolean {
  if (!query) {
    return true;
  }
  return (
    entry.featureName.toLowerCase().includes(query) ||
    entry.featureId.toLowerCase().includes(query) ||
    entry.description.toLowerCase().includes(query)
  );
}

export function toggleStarredFeatureId(
  ids: readonly string[],
  featureId: string
): string[] {
  return ids.includes(featureId)
    ? ids.filter(id => id !== featureId)
    : [featureId, ...ids];
}

/**
 * Starred flags float to a top section and are omitted from their original
 * groups so ListBox ids stay unique.
 */
export function buildFeatureFlagCatalogSections(
  groups: FeatureFlagGroup[],
  query: string,
  starredFeatureIds: readonly string[]
): FeatureFlagGroup[] {
  const starredSet = new Set(starredFeatureIds);
  const entriesById = new Map(
    groups.flatMap(group =>
      group.entries.map(entry => [entry.featureId, entry] as const)
    )
  );

  const starredEntries = starredFeatureIds.flatMap(featureId => {
    const entry = entriesById.get(featureId);
    if (!entry || !matchesFeatureFlagSearch(entry, query)) {
      return [];
    }
    return [entry];
  });

  const filteredGroups = groups
    .map(group => ({
      ...group,
      entries: group.entries.filter(
        entry =>
          !starredSet.has(entry.featureId) &&
          matchesFeatureFlagSearch(entry, query)
      )
    }))
    .filter(group => group.entries.length > 0);

  if (starredEntries.length === 0) {
    return filteredGroups;
  }

  return [{ name: 'Starred', entries: starredEntries }, ...filteredGroups];
}
